(function () {
    'use strict';

    angular.module('ib-expiry-date-module').constant('IbDatesConstants', {
        'DAYS_ARRAY': ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18',
            '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'],
        'MONTH_ARRAY': ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
        'DEFAULT_TO_YEARS': 100,
        'DEFAULT_FROM_YEARS': 0,
        'DEFAULT_OPTIONS': {
            'haveBirthdate': false
        }
    });
})();